<div class="endorsement-box">
  <h6 class="column-header">Endorsement Decision</h6>
  <div class="endorsement-decision-note">Please verify all information before endorsing this student record.</div>
  <div class="endorsement-cards">
    <button
      type="button"
      class="endorse-card"
      [class.selected]="endorseChoice === 'yes'"
      (click)="onEndorseChoiceSelect('yes')"
      [disabled]="isNotAttending || isEndorsementRestricted">
      <div class="endorse-card-label">Yes, this student is in attendance at my school this semester</div>
      <div class="endorse-card-desc">
        This student is attending my school, and the cost of attendance information is correct.
      </div>
    </button>
    <button
      type="button"
      class="endorse-card"
      [class.selected]="endorseChoice === 'no'"
      (click)="onEndorseChoiceSelect('no')"
      [disabled]="isEndorsementRestricted">
      <div class="endorse-card-label">No, this student is not in attendance at my school this semester</div>
      <div class="endorse-card-desc">This student has either withdrawn or was never in attendance.</div>
    </button>
  </div>

  <div class="endorse-action-row">
    <button
      class="close-button secondary_materials_button small_button"
      disableRipple="true"
      type="button"
      mat-stroked-button
      (click)="onCancel()">
      Cancel
    </button>
    <span [matTooltip]="restrictionTooltipMessage" [matTooltipDisabled]="!isEndorsementRestricted">
      <button
        class="primary_materials_button small_button"
        disableRipple="true"
        type="button"
        mat-stroked-button
        [disabled]="isEndorseDisabled"
        (click)="onEndorse()">
        @if (endorsing) {
          <mat-spinner diameter="16" style="display: inline-block; margin-right: 8px"></mat-spinner>
        }
        {{ endorsing ? 'Endorsing...' : (endorseChoice === 'no' ? 'Submit' : 'Endorse') }}
      </button>
    </span>
  </div>
</div>
